import { formatPrice } from '@rcg/pricing-format';
import Dictionary from './dictionary';

const renderContents = (renderContent) => {
  const nd = renderContent(Dictionary.airOrdinaryNd.key, Dictionary.airOrdinaryNd.defaultValue);
  const st = renderContent(Dictionary.airOrdinarySt.key, Dictionary.airOrdinarySt.defaultValue);
  const th = renderContent(Dictionary.airOrdinaryTh.key, Dictionary.airOrdinaryTh.defaultValue);
  const rd = renderContent(Dictionary.airOrdinaryRd.key, Dictionary.airOrdinaryRd.defaultValue);
  return {
    th,
    nd,
    rd,
    st,
  };
};
const getOrdinal = (n, renderContent) => {
  const { st, nd, rd, th } = renderContents(renderContent);
  return [st, nd, rd][(((((n < 0 ? -n : n) + 90) % 100) - 10) % 10) - 1] || th;
};

const baggageObject = (baggage, price, renderContent) => {
  const checkedBagLabel = renderContent(
    Dictionary.airCheckedBagLabel.key,
    Dictionary.airCheckedBagLabel.defaultValue,
  );
  if (typeof baggage === 'number') {
    return {
      title: `${baggage}${getOrdinal(baggage, renderContent)} ${checkedBagLabel}`,
      price,
    };
  }
  if (typeof baggage === 'object') {
    if (baggage.length === 1) {
      return {
        title: `${baggage[0]}${getOrdinal(baggage[0], renderContent)} ${checkedBagLabel}`,
        price,
      };
    }
    const freeLabel = renderContent(
      Dictionary.airFreeLabel.key,
      Dictionary.airFreeLabel.defaultValue,
    );
    const checkedBagsLabel = renderContent(
      Dictionary.airCheckedBagsLabel.key,
      Dictionary.airCheckedBagsLabel.defaultValue,
    );
    const eachLabel = renderContent(
      Dictionary.airEachLabel.key,
      Dictionary.airEachLabel.defaultValue,
    );
    const priceValue = freeLabel === price ? freeLabel : `${price} ${eachLabel}`;
    return {
      title: baggage
        .reduce((accumulator, currentValue) => {
          if (accumulator === 2) {
            return `${accumulator}${getOrdinal(
              accumulator,
              renderContent,
            )}, ${currentValue}${getOrdinal(currentValue, renderContent)}, `;
          }
          return `${accumulator}${currentValue}${getOrdinal(currentValue, renderContent)}, `;
        })
        .slice(0, -2)
        .concat(` ${checkedBagsLabel}`),
      price: priceValue,
    };
  }
  return false;
};

const createBaggages = (baggages, price, renderContent) => {
  return baggages.map((baggage) => {
    return baggageObject(baggage, price, renderContent);
  });
};

const reduceBaggages = (baggageArray, forceArray = false) => {
  if (baggageArray.length === 1) {
    return [baggageArray[0] + 1];
  }

  return baggageArray.reduce((accumulator, currentValue) => {
    let arrayNumbers = [];
    const currentBaggageNumber = currentValue + 1;
    if (typeof accumulator !== 'object') {
      if (!forceArray) {
        arrayNumbers.push(accumulator + 1);
        arrayNumbers.push([currentBaggageNumber]);
      } else {
        arrayNumbers.push([accumulator + 1, currentBaggageNumber]);
      }
    } else {
      arrayNumbers = accumulator;
      if (!arrayNumbers[1]) {
        arrayNumbers.push([currentBaggageNumber]);
      } else {
        arrayNumbers[1].push(currentBaggageNumber);
      }
    }
    return arrayNumbers;
  });
};
const checkBaggages = (freeBaggageCount) => {
  let baggages = [];
  const baggageArray = Array.from(Array(freeBaggageCount).keys());
  if (freeBaggageCount > 0) {
    baggages = reduceBaggages(baggageArray);
  }
  return baggages;
};
const buildBaggages = (baggageInfo, renderContent, currency) => {
  const { freeBaggageCount } = baggageInfo;
  const baggages = checkBaggages(freeBaggageCount);
  const freeLabel = renderContent(
    Dictionary.airFreeLabel.key,
    Dictionary.airFreeLabel.defaultValue,
  );
  let createdBaggages = createBaggages(baggages, freeLabel, renderContent);
  const currentBaggagesLength = createdBaggages.length;
  if (currentBaggagesLength <= 1) {
    const { baggageCharges } = baggageInfo;
    const baggageChargesLenght = baggageCharges ? baggageCharges.length : 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < baggageChargesLenght; i++) {
      if (createdBaggages.length === 2) {
        break;
      }
      const loopCurrentBaggagesLength = createdBaggages.length;
      const element = baggageCharges[i];
      let baggageChargeArray = Array.from(Array(element.pieceCount).keys());
      baggageChargeArray = baggageChargeArray.map((value) => {
        return value + loopCurrentBaggagesLength;
      });
      let baggagesCharge = [];
      if (element.pieceCount > 0) {
        if (createdBaggages.length >= 1) {
          baggagesCharge = reduceBaggages(baggageChargeArray, true);
        } else {
          baggagesCharge = reduceBaggages(baggageChargeArray);
        }
      }
      const createdBaggagesCharge = createBaggages(
        baggagesCharge,
        `+${formatPrice(element.price.value, currency, true, true, true)}`,
        renderContent,
      );
      createdBaggages = createdBaggages.concat(createdBaggagesCharge);
    }
  }
  return createdBaggages;
};

export default {
  buildBaggages,
};
